import "./ProfileConstitution.module.css";
import Header from "@/reusable_sections/Header";
import ProfileHero from "./sections/ProfileHero";
import ProfileContent from "./sections/ProfileContent";
import Footer from "@/reusable_sections/Footer";
export default function ProfileConstitutionPage() {
  return <div>
      <Header />
      <ProfileHero />
      <ProfileContent />
      <Footer />
    </div>;
}